import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Seo } from '@/components/Seo'

export default function NotFound() {
  return (
    <>
      <Seo title="Không tìm thấy trang" noIndex />
      <div data-upbo-src="src/pages/NotFound.tsx:9" className="mx-auto flex w-full max-w-6xl flex-col items-start gap-6 px-6 py-32">
        <p data-upbo-src="src/pages/NotFound.tsx:10" className="font-mono text-sm text-muted-foreground">404</p>
        <h1 data-upbo-src="src/pages/NotFound.tsx:11" className="text-4xl font-semibold tracking-tight">Không có trang này</h1>
        <p data-upbo-src="src/pages/NotFound.tsx:12" className="max-w-md text-muted-foreground">
          Đường dẫn bạn mở không tồn tại, hoặc đã được đổi tên.
        </p>
        <Button asChild><Link to="/">Về trang chủ</Link></Button>
      </div>
    </>
  )
}
